import React from 'react';

function LoadingSkeleton({ type = 'card' }) {
  if (type === 'card') {
    return (
      <div className="bg-card border border-border rounded-lg p-6 shadow-sm animate-pulse">
        <div className="h-4 bg-muted rounded w-3/4 mb-4"></div>
        <div className="h-3 bg-muted rounded w-1/2 mb-2"></div>
        <div className="h-3 bg-muted rounded w-2/3"></div>
      </div>
    );
  }

  if (type === 'table') {
    return (
      <div className="bg-card border border-border rounded-lg overflow-hidden">
        <div className="p-4 space-y-3">
          {[1, 2, 3, 4, 5].map(i => (
            <div key={i} className="flex gap-4 animate-pulse">
              <div className="h-4 bg-muted rounded w-1/4"></div>
              <div className="h-4 bg-muted rounded w-1/4"></div>
              <div className="h-4 bg-muted rounded w-1/6"></div>
              <div className="h-4 bg-muted rounded w-1/6"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (type === 'stat') {
    return (
      <div className="bg-card border border-border rounded-lg p-6 shadow-sm animate-pulse">
        <div className="h-3 bg-muted rounded w-1/2 mb-4"></div>
        <div className="h-8 bg-muted rounded w-1/3"></div>
      </div>
    );
  }

  return (
    <div className="animate-pulse">
      <div className="h-4 bg-muted rounded w-full"></div>
    </div>
  );
}

export default LoadingSkeleton;
